import { ComponentRef, ViewContainerRef } from '@angular/core';
import { PassKeyTermsAndConditionsComponent } from './pass-key-terms-and-conditions.component';

class PassKeyTermsAndConditionsSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  viewContainerRef: ViewContainerRef;
  passKeyTermsAndConditionsComponent: ComponentRef<PassKeyTermsAndConditionsComponent>;

  constructor(formId: string, payload: object) {

  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }
  endSession(): void {

  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {

    this.viewContainerRef.clear();

    this.passKeyTermsAndConditionsComponent = this.viewContainerRef.createComponent(PassKeyTermsAndConditionsComponent);

    this.passKeyTermsAndConditionsComponent.instance.onAcceptTermsAndConditionsSubmit = this.onAcceptTermsAndConditions.bind(this);
    this.passKeyTermsAndConditionsComponent.instance.onDeclineTermsAndConditionsSubmit = this.onDeclineTermsAndConditions.bind(this);

    // const journeyPayload = this.payload as JourneyPayload;
    // const action = journeyPayload.actions[0] as ActionsInPayload;

    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

          this.submitBlock = null;
        } catch (e) {

        }
      };
    });
  }
  onContinue(payload: object): void {

  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  /** Non UIFormSession interface Functions */
  private async onAcceptTermsAndConditions(payload: object) {
    this.submitBlock({accept: true});
  }

  private onDeclineTermsAndConditions(payload: object) {
    this.submitBlock({accept: false});
  }
  // async passkeyRegister() {
  //    const result = await (window as any).tsPlatform.webauthn.isPlatformAuthenticatorSupported();

  //    if (result )
  //     {
  //         const username = this.clientContext['cookieService'].get('userEmail-username');

  //         const res = await (window as any).tsPlatform.webauthn.register(username, {
  //         limitSingleCredentialToDevice: false ,
  //         displayName: username ,
  //         allowCrossPlatformAuthenticators: false,
  //         registerAsDiscoverable: false});

  //         if (res){
  //         // console.log(data3);


  //         this.submitBlock({
  //         action: 'submit',
  //         webauthntoken: res
  //       });
  //     }
  //   }
  //     else{

  //     }
  // }

}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default PassKeyTermsAndConditionsSession;
